import { createFileRoute } from '@tanstack/react-router';
import { AdminDuplicatesPage } from '../../features/directory';

export const Route = createFileRoute('/admin/merge')({ component: AdminDuplicatesPage });
